import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';

import { StyledModal } from './ModalStyle';

const ModalWrapper = styled(StyledModal)`
	& > div > div:first-child {
		background: var(--bs-danger-bg-subtle);
		color: var(--bs-danger-text-emphasis);
		border-color: var(--bs-danger-border-subtle);
	}
`;

const ModalBody = styled(Modal.Body)`
	font-size: 1rem;
	font-weight: 300;
`;

const ErrorModal = ({ title, text, show, onClose }) => {
	if (!show) return null;
	return (
		<ModalWrapper show={true} centered size="lg" onHide={onClose}>
			<Modal.Header closeButton>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<ModalBody>{text}</ModalBody>
		</ModalWrapper>
	);
};
export default ErrorModal;
